<template>
<v-app>
<v-sheet  outlined color="white" elevation="5" rounded class='ma-4'>
 <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Submitting your data.....
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
   <v-dialog
      v-model="dialog"
      width="500"
    >
     <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Message
        </v-card-title>

        <v-card-text class='mt-5'>
          Thank you for sharing your story with us, a confirmation email has sent out to your email, if you have any questions, please contact us at admin@geneticsupportfoundation.org
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  <v-form  ref="form" v-model="valid" class='mt-5'>
    <v-container>
      <v-row>
        <v-col
          class='pt-0  pb-0'
          cols="12"
          sm="12"
        >
          <v-text-field
            v-model="formData.Name"
            :rules="requireRule"
            label="Name*"
            required
            outlined
          ></v-text-field>
        </v-col>

       
        <v-col
        class='pt-0 pb-0'
          cols="12"
          sm="12"
        >
          <v-text-field
          
            v-model="formData.email"
            :rules="emailRules"
             label="Email*"
            outlined
            required
          ></v-text-field>
        </v-col>
           <v-col
        class='pt-0 pb-0'
          cols="12"
          sm="12"
        >
          <v-textarea
          
            v-model="formData.story"
            :rules="requireRule"
             label="Share your story, or leave a note if you'd like to be interviewed *"
            outlined
            rows="5"
            required
          ></v-textarea>
          
        </v-col>
  <v-col
        class='pt-0 pb-0'
          cols="12"
          sm="12"
        >

                 <v-checkbox
        required
      v-model="formData.anonymous"
    > <template v-slot:label>
        <div>
         I would like to remain anonymous
        </div>
      </template>
      </v-checkbox>
  </v-col>
      </v-row>
       <v-card-actions>
     <v-spacer></v-spacer>
       <button
        type='submit'
        class='gsfBtn'
        color="green"
         @click='validate'
      >
      Submit
      </button>
    </v-card-actions>
    </v-container>
  </v-form>

  
</v-sheet>
</v-app>
</template>

<script>
export default {
  data(){
    return{
      loadingDialog: false,
      dialog: false,
      formData : {
        anonymous:false,
      story : "",
      Name : "",
       email : "",
      },
      valid : false,
      requireRule : [
         v => !!v || 'This field is required',
      ],
       emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
  }
},
    computed: {

    },
mounted(){
  console.log("app mounted");
},
 watch: {
    },
    methods: {
      async validate (e) {
        e.preventDefault();
        this.valid = this.$refs.form.validate();
        if(this.valid){
          this.loadingDialog = true;
          await this.$axios.post("https://us-central1-gsf-ehr.cloudfunctions.net/public/shareyourstory",{
                formData : this.formData
            })
            this.loadingDialog = false;
            this.dialog = true;
            
        }

      },
      save (date) {
        this.$refs.menu.save(date)
      },
    },
}
</script>

<style>
.gsfBtn{

    color: #ffffff !important;

    background: #399342;

    border-radius: 5px;

    padding-top: 10px;

    padding-bottom: 10px;

    padding-left: 17px;

    padding-right: 16px;
}


.gsfBtn:hover {
    background: #5ab163;

}

input[type=email],input[type=password],input[type=search],input[type=tel],input[type=text],input[type=url],textarea {
    border:0px solid #ccc !important; 
}

.v-application--wrap{
  min-height : 0vh !important;
}
.theme--light.v-application{
  background: transparent !important;
}
</style>